<tt-page>
    <ng-container *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="list"></ng-container>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="selectoperationpu_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <ng-container *ngTemplateOutlet="list"></ng-container>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-container>
</tt-page>

<ng-template #list>
    <ng-container>
        <tt-card>
            <tt-tabs [(ttSelectedId)]="selectedBgOptions" (ttSelectedIdChange)="onTabChanged()">
                <tt-tab ttId="1" ttLabel="operation_direct"></tt-tab>
                <tt-tab ttId="0" ttLabel="operation_indirect"></tt-tab>
            </tt-tabs>
        </tt-card>

        <tt-list [ttData]="itemsListOperations" ttBackStyle [ttGoto]="false" (ttClick)="goBackToPrevious($event)"></tt-list>
    </ng-container>
</ng-template>
